module.exports = __webpack_public_path__ + "static/4616ab13-7950-4b3d-9402-02e4f86c441f-700.3874d35b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/barkVase-tangerine/4616ab13-7950-4b3d-9402-02e4f86c441f-700.jpg
// module id = 927
// module chunks = 168707334958949